import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Tooltip } from "@material-ui/core";

const iconStyle = {
  width: 25,
  height: 25,
};

const IconButtonLoader = React.forwardRef(
  (
    {
      icon,
      size,
      title,
      onClick,
      extraStyle,
      forceLoading,
      ...iconButtonProps
    },
    ref
  ) => {
    const [loading, setLoading] = useState();
    const action = useCallback(
      async (e) => {
        e.preventDefault();

        try {
          setLoading(true);

          await onClick();
        } catch (error) {
          console.log("error" + error);
        } finally {
          setLoading(false);
        }
      },
      [onClick]
    );
    const style = { ...iconStyle, ...extraStyle };

    return forceLoading || loading ? (
      <CircularProgress ref={ref} style={style} />
    ) : (
      <Tooltip
        title={title}
        style={style}
        onClick={action}
        size={size}
        {...iconButtonProps}
      >
        {icon}
      </Tooltip>
    );
  }
);

IconButtonLoader.displayName = "IconButtonLoader";

IconButtonLoader.propTypes = {
  /**
   * Componente que será exibido dentro do botão de ícone. De preferência um ícone.
   */
  icon: PropTypes.node.isRequired,
  /**
   * Tamanho do botão de ícone
   */
  size: PropTypes.string.isRequired,
  /**
   * Título do ícone (exibido ao passar o mouse).
   */
  title: PropTypes.string,
  /**
   * Função assincrona que será executada ao clicar no ícone.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Objeto com estilos adicionais para o IconButton e o CircularProgress
   */
  extraStyle: PropTypes.object,
  /**
   * Força o loading no lugar do icone
   */
  forceLoading: PropTypes.bool,
};

export default IconButtonLoader;
